module.exports = __webpack_public_path__ + "static/media/aexpress.436f6271.svg";